export default "__VITE_ASSET__CQJT2G64__"